module.exports = __webpack_public_path__ + "static/am-847ba96a8354ba497989e03efbb34b4c.svg";